import React from "react";
import { ReactComponent as AddTaskCrosIcn } from "../../assets/images/addTaskCrosIcn.svg";
import FloatingList from "../UniversalComponents/FloatingElement";
const DelegationSelection = ({
  depth,
  handleMouseLeave,
  handleCheck,
  formData,
  personTableData,
  handleSelectPerson,
  searchTerm,
  personCountAllowed,
  isMultiSelect,
}) => {
  return (
    <FloatingList vertical={0} mode="vertical">
      <div className="w-[294px]   mt-2 bg-white rounded-md border shadow-3 pt-3 mb-6 z-[1] min-h-72 ">
        <div
          onMouseLeave={() => {
            handleMouseLeave(depth);
          }}
        >
          <input
            type="text"
            autoFocus="autoFocus"
            placeholder="Type a name or email address"
            className="ml-2 w-[270px] h-[38px] border-[#B6BBBF] bg-[#F8F8F8] rounded-md text-[12px] font-[400] text-[#848687] mb-2"
            value={searchTerm[depth] || ""}
            onChange={(e) => {
              handleCheck(depth, e);
            }}
          />

          <div className="pb-3 align-center ">
            <h3 className="text-14 font-500 ml-4 mb-2 ">Assigned</h3>
            <ul className="list-none max-h-[86px] overflow-y-auto">
              {formData?.assigned_to?.map((eachInput, index) => {
                const initials = eachInput.name
                  .split(" ")
                  .filter((word) => word.length > 0)
                  .map((word) => word.charAt(0).toUpperCase())
                  .slice(0, 2)
                  .join("");
                return (
                  <li
                    key={index}
                    className="list-none cursor-pointer py-1"
                    onClick={(e) => handleSelectPerson(e, eachInput, personCountAllowed)}
                  >
                    <div className="flex justify-between items-center">
                      <div className="text-[#2999BC] text-12 font-400 flex pl-4 space-x-2">
                        <div className="bg-white text-12 font-600 border-[#AAC9DB] p-[10px] w-5 h-5 flex items-center justify-center rounded-full border-[1px]">
                          {initials}
                        </div>
                        <p className="mb-1 ">{eachInput.name}</p>
                      </div>
                      <div className="pr-6 mb-1">
                        <AddTaskCrosIcn />
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
          <div>
            <h3 className="text-14 font-500 ml-4 pb-3">Suggestions</h3>
          </div>

          <ul className="pl-5 text-12 font-400 space-y-3 text-[#2999BC] max-h-[100px] overflow-y-auto  ">
            {personTableData &&
              (isMultiSelect ? personTableData : personTableData?.data)
                ?.filter(
                  (eachInput) =>
                    eachInput.name?.toLowerCase().includes(searchTerm[depth]?.toLowerCase() || "") &&
                    !formData.assigned_to.some((eachValue) =>
                      eachValue.name?.toLowerCase().includes(eachInput.name?.toLowerCase())
                    )
                )
                .map((eachInput, index) => {
                  const initials = eachInput.name
                    .split(" ")
                    .filter((word) => word.length > 0)
                    .map((word) => word.charAt(0).toUpperCase())
                    .slice(0, 2)
                    .join("");

                  return (
                    <div className="flex space-x-2 cursor-pointer" key={index}>
                      <div className="bg-white text-12 font-600 border-[#AAC9DB] p-[10px] w-5 h-5 flex items-center justify-center rounded-full border-[1px]">
                        {initials}
                      </div>
                      <li onClick={(e) => handleSelectPerson(e, eachInput, personCountAllowed)}>{eachInput.name}</li>
                    </div>
                  );
                })}
          </ul>
        </div>
      </div>
    </FloatingList>
  );
};

export default DelegationSelection;
